import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { PageHeader } from '../components/page/PageHeader';
import { CtaBand } from '../components/page/CtaBand';
import { Reveal } from '../components/ui/Reveal';
import { Badge } from '../components/ui/Badge';
import { CASE_STUDIES } from '../components/caseStudiesData';
export const CaseStudies = () => {
  return <>
      <PageHeader eyebrow="Case Studies" title="Teams moving from discovery to activation" subtitle="How brands and marketing agencies use Zano to source and manage talent agency relationships at scale." data-id="element-1903" />

      {/* Grid */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 pb-16" data-id="element-1904">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1905">
          {CASE_STUDIES.map((c, i) => <Reveal key={c.slug} delay={i % 2 * 0.1} data-id="element-1906">
              <Link to={`/case-studies/${c.slug}`} className="group flex flex-col h-full bg-white rounded-3xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-float hover:-translate-y-1 transition-all duration-300" data-id="element-1907">
                <div className={`h-40 w-full flex items-center justify-center p-8 ${c.logoBg}`} data-id="element-1908">
                  <img src={c.logo} alt={`${c.brand} logo`} className="max-h-full max-w-[180px] object-contain transition-transform duration-500 group-hover:scale-105" data-id="element-1909" />
                </div>
                <div className="p-8 flex flex-col flex-1" data-id="element-1910">
                  <div className="flex flex-wrap gap-2 mb-4" data-id="element-1911">
                    {c.tags.map(tag => <Badge key={tag} className="bg-blue-50 border border-blue-200 text-blue-700" data-id="element-1912">
                        {tag}
                      </Badge>)}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 leading-snug group-hover:text-zano-pink transition-colors" data-id="element-1913">
                    {c.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1" data-id="element-1914">
                    {c.subtitle}
                  </p>
                  <div className="flex items-center text-sm font-bold text-zano-pink mt-auto" data-id="element-1915">
                    Read Case Study
                    <ArrowUpRight size={16} className="ml-1 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" data-id="element-1916" />
                  </div>
                </div>
              </Link>
            </Reveal>)}
        </div>
      </section>

      <CtaBand title="Be the next team to ditch the spreadsheets" subtitle="Start a free trial today and access the elite layer of talent representation." primaryCta={{
      label: 'Start Free Trial',
      to: '/pricing'
    }} data-id="element-1917" />
    </>;
};